export default {
    title: 'You have successfully scheduled the free 1-on-1 trial session.',
    title1: 'Please wait until our staff contact you.',
    title2: 'Or you can scan code on WhatsApp and contact our staff.',
    title3: 'Follow us on Facebook to get FREE learning materials!',
    title4: `Your application has been received and Please add the WhatsAPP 
    account below for futher information with our professional consultant.`,
    title5: 'WhatsAPP account',
    title6: `Your first tutoring class is totally free and we will offer you extra learning 
    resources after your appointment`,
    title7: `Your application has been received and we'll contact you in 24
    hours，please pay attention to the incoming call.`,
    copy: 'Copy',
    copied: 'Copied',
    success: 'Success',
}